import {
  Stack,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { materialGoodsReceiptBusiness } from "api/bussiness/material/material-goods-receipt";
import { MaterialInventoriesPermission } from "commons/enum/permission";
import { dateTimeDisplay } from "commons/ultilities/date/dayjs";
import { cloneDeep } from "lodash";
import { observer } from "mobx-react-lite";
import { IMaterialGoodsReceiptProperties } from "mobx-stores/_models/material-inventory/material-goods-receipt/material-goods-receipt";
import { useStores } from "mobx-stores/_root-store";
import { useCallback, useEffect } from "react";
import { NumberText } from "share-components/atomics/number-text";
import {
  EditIconButton,
  RemoveIconButton,
} from "share-components/mui-wrap/button/action-button";
import { XTablePagination } from "share-components/mui-wrap/table/x-table-pagination";
export const MaterialGoodsReceiptTable = observer(() => {
  const {
    deleteConfirmationStore,
    materialInventoryManagement: {
      materialGoodsReceiptStore: {
        materialGoodsReceipts,
        getMaterialGoodsReceipt,
        pagination,
        setProp,
      },
    },
  } = useStores();

  useEffect(() => {
    getMaterialGoodsReceipt();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onPageChanged = useCallback(
    (_: any, page: number) => {
      pagination.setProp("pageIndex", page - 1);
      getMaterialGoodsReceipt();
    },
    [getMaterialGoodsReceipt, pagination],
  );

  const onEditBtnClickHandler = useCallback(
    (item: IMaterialGoodsReceiptProperties) => {
      setProp("openEdit", true);
      setProp("materialGoodsReceiptDetail", cloneDeep(item));
    },
    [setProp],
  );

  const onDelete = useCallback(
    async (item: IMaterialGoodsReceiptProperties) => {
      if (item && item.id) {
        await materialGoodsReceiptBusiness.delete(item?.id);
        getMaterialGoodsReceipt();
      }
    },
    [getMaterialGoodsReceipt],
  );

  const onDeleteBtnClickHandler = useCallback(
    (item: IMaterialGoodsReceiptProperties) => {
      setProp("materialGoodsReceiptDetail", cloneDeep(item));
      deleteConfirmationStore.setProp("open", true);
      deleteConfirmationStore.setDeletionCallback(() => {
        onDelete(item);
      });
    },
    [deleteConfirmationStore, onDelete, setProp],
  );

  return (
    <XTablePagination
      paginationProps={{
        count: pagination.totalPages,
        page: pagination.pageNumber,
        onChange: onPageChanged,
      }}
    >
      <TableHead>
        <TableRow>
          <TableCell style={{ textWrap: 'nowrap' }}>Bộ phận/Khâu SX</TableCell>
          <TableCell>Loại Hàng</TableCell>
          <TableCell>Tên Hàng (Mã Hàng)</TableCell>
          <TableCell>Mã barcode</TableCell>
          <TableCell>Dài (Ngang)</TableCell>
          <TableCell>Rộng (Dọc)</TableCell>
          <TableCell>Cao (Dày)</TableCell>
          <TableCell>Ngày nhập</TableCell>
          <TableCell>ĐVT</TableCell>
          <TableCell>Số lượng</TableCell>
          <TableCell>Vị trí kho</TableCell>
          <TableCell>Hiệu</TableCell>
          <TableCell>Mã hàng</TableCell>
          <TableCell>Xuất xứ</TableCell>
          <TableCell>Nhà CC</TableCell>
          <TableCell>Chứng từ</TableCell>
          <TableCell>Ghi chú</TableCell>
          <TableCell></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {materialGoodsReceipts.map((x, i) => (
          <TableRow data-id={x.id} key={x.id} hover>
            <TableCell>{x.items[0]?.material?.code || ""}</TableCell>
            <TableCell>{x.items[0]?.material?.type || ""}</TableCell>
            <TableCell>{x.items[0]?.material?.name || ""}</TableCell>
            <TableCell>{x.items[0]?.material?.barcode || ""}</TableCell>
            <TableCell>
              {x.items[0]?.material?.specificationSize || ""}
            </TableCell>
            <TableCell>
              {x.items[0]?.material?.specificationLength || ""}
            </TableCell>
            <TableCell>
              {x.items[0]?.material?.specificationThick || ""}
            </TableCell>
            <TableCell>{dateTimeDisplay(x.receiptDate) || ""}</TableCell>
            <TableCell>{x.items[0]?.unitOfCalculation || ""}</TableCell>
            <TableCell>
              <NumberText value={x.items[0]?.amount}></NumberText>
            </TableCell>
            <TableCell>{x.items[0]?.wareHouse || ""}</TableCell>
            <TableCell>{x.items[0]?.brand || ""}</TableCell>
            <TableCell>{x.items[0]?.code || ""}</TableCell>
            <TableCell>{x.items[0]?.origin || ""}</TableCell>
            <TableCell>{x.items[0]?.supplier || ""}</TableCell>
            <TableCell>{x.items[0]?.document || ""}</TableCell>
            <TableCell>{x.items[0]?.note || ""}</TableCell>
            <TableCell width={"20px"}>
              <Stack direction={"row"} spacing={0.5}>
                <EditIconButton
                  accessPermission={[
                    MaterialInventoriesPermission.ReceiptUpdate,
                  ]}
                  onClick={() => onEditBtnClickHandler(x)}
                ></EditIconButton>

                <RemoveIconButton
                  accessPermission={[
                    MaterialInventoriesPermission.ReceiptDelete,
                  ]}
                  onClick={() => onDeleteBtnClickHandler(x)}
                ></RemoveIconButton>
              </Stack>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </XTablePagination>
  );
});
